import { useEffect, useState } from 'react';

function findBannerElement(): HTMLElement | null {
    return ((document.getElementById('cookiescript_injected') as HTMLElement | null)
        || (document.querySelector('[id*="cookiescript"]') as HTMLElement | null)
        || (document.querySelector('.cookiescript') as HTMLElement | null)
        || (document.querySelector('#fake-consent') as HTMLElement | null));
}

function isElementVisible(el: HTMLElement | null): boolean {
    if (!el) {
        return false;
    }
    // Consider actual visibility not just presence
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
        return false;
    }
    // Hidden via attribute
    if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') {
        return false;
    }
    // Not in layout tree
    if (el.offsetParent === null && style.position !== 'fixed') {
        return false;
    }
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
}

export const useCookieBannerShow = () => {
    const [ isCookieBannerVisible, setIsCookieBannerVisible ] = useState(false);

    useEffect(() => {
        const update = () => setIsCookieBannerVisible(isElementVisible(findBannerElement()));

        update();

        // Observe DOM mutations that might show/hide the banner
        const observer = new MutationObserver(() => {
            update();
        });
        try {
            observer.observe(document.documentElement, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: [ 'style', 'class', 'hidden', 'aria-hidden' ]
            });
        } catch {}

        // Fallback: infrequent polling in case style changes aren't captured
        const interval = window.setInterval(update, 1500);

        return () => {
            observer.disconnect();
            window.clearInterval(interval);
        };
    }, []);

    return { isCookieBannerVisible };
};
